<template>
  <div class="jump-usercenter nav-bar-fixed">
    <!-- 站内咨询 -->

    <van-nav-bar
      :title="type==1?'技术咨询':'站内咨询'"
      left-arrow
      fixed
      class="jump-nav-bar"
      @click-left="back"
    />
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <van-tabs v-model="tabActive" @click="tabsType">
        <van-tab class="jump-cons-tab" title="全部咨询" style="background:#fff">
           
          <!-- 聊天 对话框的样式 -->
          <!-- <div class="item" v-for="item in list" >
            <div class="status">
                <span style="color:#3c6eeb">{{item.reply==false?'未回复':'已回复'}}</span>
                 <van-icon name="delete" @click="condel(item.id)" v-if="item.flag==1" style="float:right;"/>
            </div>
            <div class="time">
              {{item.createtime}}
              </div> -->
              <!-- 提问 -->
            <!-- <div class="sendBox">
                <div>  {{item.userName}} </div>
                <div class="cont">
                      <div class="avator">
                  <img src="../../assets/avatar.png"/>
                  </div>
              <div class="send">
                    <div class="arrow"></div>
                   {{item.consult_content}}
              </div>
                </div>
            
            </div> -->
            <!-- 回复 -->
            <!-- <div class="time" v-if="item.reply">
              {{item.reply_time}}
             </div>
            <div class="replayBox" v-if="item.reply">
            <div style="text-align:right">  {{item.userName}} </div>
                <div class="cont">
                      <div class="avator">
                  <img src="../../assets/avatar.png"/>
                  </div>
              <div class="replay">
                    <div class="arrow"></div>
                   {{item.consult_content}}
              </div>
                </div>
            </div> -->
            <!-- 再次回复 -->
            <!-- <div v-if="item.flag==1" class="edit">
                 <van-field type="textarea" v-model="content[item.id]"  rows="1" placeholder="请输入您要回复的信息"/>
                 <van-button size="small" @click="save(item.id)" class="button">回复</van-button>
            </div> -->
             <!-- <van-col span="24" class="text-right" v-if="item.flag==1">
              <van-field type="textarea" v-model="content[item.id]" placeholder="请输入您要回复的信息" />
              <van-button size="small" @click="save(item.id)">回复</van-button>
            </van-col> -->

          <!-- </div> -->
          <van-row class="jump-cons-item" v-for="item in list">
            <van-col span="12">
              <p class="item-header">
                {{item.userName}}
                <span>{{item.reply==false?'未回复':'已回复'}}</span>
              </p>
            </van-col>
            <van-col span="12">
              <p class="item-time">
                {{item.createtime}}
                <van-icon name="delete" @click="condel(item.id)" v-if="item.flag==1" />
              </p>
            </van-col>
            <van-col span="24">
              <p >{{item.consult_content}}</p>
            </van-col>

            <van-col span="24" class="text-right" v-if="item.flag==1">
              <van-field type="textarea" v-model="content[item.id]" placeholder="请输入您要回复的信息" />
              <van-button size="small" @click="save(item.id)">回复</van-button>
            </van-col>

            <van-col span="12" v-if="item.reply">
              <p class="item-header">
                {{item.reply_userName}}
                <!--<span>已回复</span>-->
              </p>
            </van-col>
            <van-col span="12" v-if="item.reply">
              <p class="item-time">
                {{item.reply_time}}
                <!--<van-icon name="delete"/>-->
              </p>
            </van-col>
            <van-col span="24" v-if="item.reply">
              <p>{{item.consult_reply}}</p>
            </van-col>
          </van-row>
        </van-tab>
        <van-tab title="未回复咨询" class="jump-cons-tab">
          <van-row class="jump-cons-item" v-for="item in list">
            <van-col span="12">
              <p class="item-header">
                {{item.userName}}
                <span>{{item.reply==false?'未回复':'已回复'}}</span>
              </p>
            </van-col>
            <van-col span="12">
              <p class="item-time">
                {{item.createtime}}
                <van-icon name="delete" @click="condel(item.id)" v-if="item.flag==1" />
              </p>
            </van-col>
            <van-col span="24">
              <p>{{item.consult_content}}</p>
            </van-col>

            <van-col span="24" class="text-right" v-if="item.flag==1">
              <!-- <a href="#">查看</a>-->
              <van-field type="textarea" v-model="content[item.id]" />
              <van-button size="small" @click="save(item.id)">回复</van-button>
            </van-col>
          </van-row>
        </van-tab>
        <van-tab title="已回复咨询" class="jump-cons-tab">
          <van-row class="jump-cons-item" v-for="item in list">
            <van-col span="12">
              <p class="item-header">
                {{item.userName}}
                <span>{{item.reply==false?'未回复':'已回复'}}</span>
              </p>
            </van-col>
            <van-col span="12">
              <p class="item-time">
                {{item.createtime}}
                <van-icon name="delete" @click="condel(item.id)" v-if="item.flag==1" />
              </p>
            </van-col>
            <van-col span="24">
              <p>{{item.consult_content}}</p>
            </van-col>

            <van-col span="24" class="text-right" v-if="item.flag==1">
              <!-- <a href="#">查看</a>-->
              <van-field type="textarea" v-model="content[item.id]" />
              <van-button size="small" @click="save(item.id)">回复</van-button>
            </van-col>

            <van-col span="12">
              <p class="item-header">
                {{item.reply_userName}}
                <!--<span>已回复</span>-->
              </p>
            </van-col>
            <van-col span="12">
              <p class="item-time">
                {{item.reply_time}}
                <!--<van-icon name="delete"/>-->
              </p>
            </van-col>
            <van-col span="24">
              <p>{{item.consult_reply}}</p>
            </van-col>
          </van-row>
        </van-tab>
      </van-tabs>
    </van-list>
  </div>
</template>
<script>
import { NavBar, Row, Col, Tab, Tabs, Button, List, Field } from "vant";

export default {
  name: "usercons",
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [Field.name]: Field,
    [List.name]: List
  },
  data() {
    return {
      tabActive: 0,
      replyFlag: "",
      list: [],
      loading: false,
      finished: false,
      content: [],
      total: 0,
      page: 1,
      type: ""
    };
  },
  mounted: function() {
    this.type = this.$route.query.type ? this.$route.query.type : "0"; //技术咨询1。站内咨询0
    console.log(this.type);
    // this.selCounselListPage()
    let that = this;
    /*// 异步更新数据
            that.$api.post(
                that.jumuc.userCenter.selCounselListPage,
                {"currentPage": that.page, "pageSize": 10, "replyFlag": that.replyFlag},
                successRes => {
                    let orderlist = successRes.data.list
                    for (let i = 0; i < orderlist.length; i++) {
                        that.list.push(orderlist[i]);
                    }
                    that.page = successRes.data.pageNum + 1
                    that.total = successRes.data.total
                    // 加载状态结束
                    that.loading = false;

                    // 数据全部加载完成
                    if (this.list.length >= that.total) {
                        that.finished = true;
                    }
                }
            )*/
  },
  methods: {
    back() {
      history.back();
    },
    onLoad() {
      let that = this;
      // 异步更新数据
      that.$api.post(
        that.jumuc.userCenter.selCounselListPage,
        {
          currentPage: that.page,
          pageSize: 10,
          replyFlag: that.replyFlag,
          type: this.type
        },
        successRes => {
          let orderlist = successRes.data.list;
          for (let i = 0; i < orderlist.length; i++) {
            that.list.push(orderlist[i]);
          }
          that.page = successRes.data.pageNum + 1;
          that.total = successRes.data.total;
          // 加载状态结束
          that.loading = false;

          // 数据全部加载完成
          if (this.list.length >= that.total) {
            that.finished = true;
          }
        }
      );
    },
    tabsType(index) {
      let that = this;
      that.list = [];
      // 异步更新数据
      that.$api.post(
        that.jumuc.userCenter.selCounselListPage,
        {
          currentPage: 1,
          pageSize: 10,
          replyFlag: index == 0 ? "" : index - 1,
          type: this.type
        },
        successRes => {
          let orderlist = successRes.data.list;
          for (let i = 0; i < orderlist.length; i++) {
            that.list.push(orderlist[i]);
          }
        }
      );
    },
    save(id) {
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.consult_reply_save,
        { id: id, consult_reply: that.content[id] },
        successRes => {
          that.$toast(successRes.msg);
          if (successRes.success) {
            that.$router.push({ path: "/user/cons" });
          }
        }
      );
    },
    condel(id) {
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.consult_del,
        { id: id },
        successRes => {
          that.$toast(successRes.msg);
          if (successRes.success) {
            that.$router.push({ path: "/user/cons" });
          }
        }
      );
    }
  }
};
</script>
<style lang="less">
@bule-thame: #3c6eeb;

body {
  background-color: #f7f7f7;
}

.jump-nav-bar-rhd {
  color: #fff;
  font-size: 16px;
  i {
    font-size: 20px;
  }
  span {
    margin-left: 5px;
  }
}

.jump-usercenter {
}
.jump-cons-tab {
  font-family: PingFangSC-Regular;
  color: rgb(153, 153, 153);
  font-size: 14px;
}

.jump-cons-item {
  padding: 10px;
  border-radius: 15px;
  background-color: #fff;
  margin-top: 10px;
  p {
    font-size: 16px;
  }
  .van-button {
    padding: 0 15px;
    background-color: @bule-thame;
    border-color: @bule-thame;
    color: #fff;
    font-size: 14px;
    border-radius: 8px;
  }
  .item-header {
    color: @bule-thame;
    font-size: 16px;
    margin-bottom: 10px;
    span {
      margin-left: 10px;
      color: red;
      &.noread {
        color: red;
      }
    }
  }
  .item-time {
    font-size: 16px;
    text-align: right;
    i {
      color: @bule-thame;
      font-size: 18px;
      vertical-align: -2px;
      margin-left: 5px;
    }
  }
}

    .jump-cons-item {
        padding: 10px;
        border-radius: 15px;
        background-color: #fff;
        margin-top: 10px;
        p {
            font-size: 16px;
            word-break:break-all;
        }
        .mcmc{
            font-size:14px;
        }
        .van-button {
            padding: 0 15px;
            background-color: @bule-thame;
            border-color: @bule-thame;
            color: #fff;
            font-size: 14px;
            border-radius: 8px;
        }
        .item-header {
            color: @bule-thame;
            font-size: 16px;
            // margin-bottom: 10px;
            span {
                margin-left: 10px;
                color: red;
                &.noread {
                    color: red;
                }
            }
        }
        .item-time {
            font-size: 16px;
            text-align: right;
            i {
                color: @bule-thame;
                font-size: 18px;
                vertical-align: -2px;
                margin-left: 5px;
            }
        }
        a {
            color: @bule-thame;
            font-size: 16px;
            margin-right: 20px;
        }
    }
    .van-field--min-height .van-field__control {
        min-height: 90px;
    }
</style>